







































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Unauthorized extends Vue {
    // el guard marca retry=1 cuando no pudo verificar ni renovar el token:
    // es un problema de conexion, no de permisos
    get couldNotVerify(): boolean {
        return this.$route.query.retry === '1';
    }

    // Solo rutas del panel: el redirect viene en la URL y no puede mandar al
    // usuario a otro sitio. Se valida lo que entiende el parser del navegador
    // y no el texto: "//sitio", "/\sitio" o "/<tab>/sitio" (los tabs y saltos
    // de linea se borran al parsear) terminan en otro host.
    get retryTarget(): string {
        const { redirect } = this.$route.query;

        if (typeof redirect !== 'string') {
            return '/panel';
        }

        try {
            const target = new URL(redirect, window.location.origin);

            if (target.origin === window.location.origin) {
                return target.pathname + target.search + target.hash;
            }
        } catch (e) {
            // URL mal formada: se trata igual que una que apunta afuera
        }

        return '/panel';
    }

    // Recarga completa y no un push del router: vuelve a iniciar Auth0 y el
    // socket, y el guard pide un token nuevo si el guardado ya no sirve.
    retry(): void {
        window.location.assign(this.retryTarget);
    }

    logout(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.$auth.logout({
            returnTo: window.location.origin,
        });
        localStorage.clear();

        sessionStorage.setItem('token', '');
    }
}
